import { RootState } from 'store/configureStore';

export const cohortProgramListSelector = (store: RootState) =>
  store.cohortProgram.cohortList;
export const isCohortProgramLoadingSelector = (store: RootState) =>
  store.cohortProgram.isLoading;
export const isMatchedCohortProgramLoadingSelector = (store: RootState) =>
  store.cohortProgram.isLoading;
export const matchedCohortProgramLoadingSelector = (store: RootState) =>
  store.cohortProgram.matchedCohortList.list;
export const cohortProgramIsMutatingSelector = (store: RootState) =>
  store.cohortProgram.isMutatingCohortProgram;
